export class SubmissionListLogic {
  /**
   * Mostra il pulsante di modifica al posto del pulsante di visualizzazione.
   */
  static showSubmissionListEditButton() {
    return process.env.ENABLE_SUBMISSION_LIST_EDIT_BUTTON === 'true';
  }
}
